<!-- duda del toast -->
<p-toast position="top-center"></p-toast>
<router-outlet></router-outlet>
<div *ngIf="showCalendar" class="p-component-overlay" style="z-index: 1102"></div>